import { render, staticRenderFns } from "./MatchMakingPreSession.vue?vue&type=template&id=4bb21e9d&scoped=true"
import script from "./MatchMakingPreSession.vue?vue&type=script&lang=js"
export * from "./MatchMakingPreSession.vue?vue&type=script&lang=js"
import style0 from "./MatchMakingPreSession.vue?vue&type=style&index=0&id=4bb21e9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb21e9d",
  null
  
)

export default component.exports